import { Logger } from "./logger";
import ShopPromoLarge from "./large/shoppromo_large";
import ShopPromoSmall from "./small/shoppromo_small";
import PromoBrandShopPromo from "./brand/promo_brandshoppromo";

window.o_promo_shoppromo = {
    ShopPromoLarge,
    ShopPromoSmall,
    PromoBrandShopPromo
}
Logger.log("Module ft3.promo.shoppromo module is loaded and the global o_promo_shoppromo object is initialized. The initialization is triggered directly in the template!");